export default [
  {
    path: '/log',
    name: 'log',
    component: () => import('@/app-modulo/comuns/log/Log.vue'),
    meta: {
      resource: 'log',
      action: 'read',
      pageTitle: 'Log geral',
      breadcrumb: [],
    },
  },
]
